import { useNavigate } from 'react-router';
import { RoutesPaths } from '../../Router/constant';

export default function ErrorPage() {
    const navigate = useNavigate();
    return (
        <div className="notfound-container">
            <img
                onClick={() => navigate(RoutesPaths.DASHBOARD)}
                src="assets/img/inproved-logo.svg"
                className="inproved-logo-error cursorPointer"
                alt="kimbocorp"
            />
            <img src="/assets/img/error_bg.png" alt="" />
            <p className="notfound-message">Opps! page not found.</p>
            <button className="notfound-button" onClick={() => navigate(RoutesPaths.HOME)}>
                Back to home
            </button>
        </div>
    )
}
